import { useDeleteDialog } from 'hooks/admin/useDeleteDialog'
import { useEffect } from 'react'
import { ImageType } from 'types/Image'
import { ShowImageData } from 'types/Show'

import { Container, ImageContainer, RemoveButton, SelectableImage } from './selectImage.style'

interface Props {
    imageOptions: ImageType[]
    selectedImage: string | null
    setSelectedImage: React.Dispatch<React.SetStateAction<string | null>>
    setImageOptions: React.Dispatch<React.SetStateAction<ImageType[]>>
    setUploadedImages: React.Dispatch<React.SetStateAction<ShowImageData[]>>
}

export const SelectImage = ({ imageOptions, selectedImage, setSelectedImage, setImageOptions, setUploadedImages }: Props) => {
    const { show: showDeleteDialog, DialogComponent: DeleteDialog } = useDeleteDialog()

    const handleImageClick = (imageId: string) => {
        setSelectedImage(imageId)
    }

    const handleRemoveImage = (imageId: string) => {
        showDeleteDialog(() => {
            setImageOptions((prevOptions) => prevOptions.filter((image) => image.image_id !== imageId))
            setUploadedImages((prevImages) => prevImages.filter((image) => image.image_id !== imageId))
        })
    }

    useEffect(() => {
        if (imageOptions.length > 0) {
            setSelectedImage(imageOptions[0].image_id)
        }
    }, [imageOptions, setSelectedImage])

    return (
        <Container>
            {imageOptions.map((image) => (
                <ImageContainer key={image.image_id}>
                    <SelectableImage
                        src={image.image_url}
                        alt="Uploaded"
                        isSelected={selectedImage === image.image_id}
                        onClick={() => handleImageClick(image.image_id)}
                    />
                    <RemoveButton label="Törlés" onClick={() => handleRemoveImage(image.image_id)} />
                </ImageContainer>
            ))}
            <DeleteDialog entityLabel={'a képet'} />
        </Container>
    )
}
